import { useEffect, useState } from 'react'
import { useApi } from './api'
import type { Order, OrderStatus } from '../types'

interface UseOrdersListOptions {
  fixedStatus?: OrderStatus
}

export function useOrdersList({ fixedStatus }: UseOrdersListOptions = {}) {
  const { apiFetch } = useApi()
  const [orders, setOrders] = useState<Order[]>([])
  const [total, setTotal] = useState(0)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)
  const [statusFilter, setStatusFilter] = useState<OrderStatus | ''>('')
  const [search, setSearch] = useState('')
  const [page, setPage] = useState(1)
  const PAGE_SIZE = 20

  useEffect(() => {
    setLoading(true)
    setError(null)
    const params = new URLSearchParams({
      limit: String(PAGE_SIZE),
      offset: String((page - 1) * PAGE_SIZE),
      archived: 'false',
    })
    const effectiveStatus = fixedStatus ?? statusFilter
    if (effectiveStatus) params.set('status', effectiveStatus)
    if (search) params.set('q', search)

    apiFetch<{ orders: Order[]; total: number }>(`/api/orders?${params}`)
      .then(({ orders: o, total: t }) => {
        setOrders(o)
        setTotal(t)
      })
      .catch((e: unknown) => setError(e instanceof Error ? e.message : 'Fehler beim Laden der Aufträge'))
      .finally(() => setLoading(false))
  }, [page, statusFilter, search, fixedStatus]) // eslint-disable-line react-hooks/exhaustive-deps

  const totalPages = Math.ceil(total / PAGE_SIZE)

  return {
    orders,
    total,
    loading,
    error,
    statusFilter,
    setStatusFilter,
    search,
    setSearch,
    page,
    setPage,
    totalPages,
    PAGE_SIZE,
  }
}
